import {NgxUiLoaderConfig, PB_DIRECTION, POSITION, SPINNER} from 'ngx-ui-loader';
import {THEME} from '../../theme/theme.config';

export const loaderConfig: NgxUiLoaderConfig = {
  bgsColor: "green",
  bgsOpacity: 40,
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 60,
  blur: 5,
  bgsType: SPINNER.squareJellyBox,
  fastFadeOut: true,
  fgsColor: THEME.primary,
  fgsPosition: POSITION.centerCenter,
  fgsSize: 60,
  fgsType: SPINNER.squareJellyBox,
  gap: 24,
  logoPosition: POSITION.centerCenter,
  logoSize: 120,
  logoUrl: "",
  masterLoaderId: "master",
  overlayBorderRadius: "0",
  overlayColor: "rgba(40, 40, 40, 0.8)",
  pbColor: "red",
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  hasProgressBar: false,
  text: "",
  textColor: "#FFFFFF",
  textPosition: POSITION.centerCenter,
}
